import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import TrackingsModule from '../components/TrackingsModule';
import { GetActivityTrackings } from '../../../store/ActivityAction';
import { RequestState } from '../../../models/RequestState';
import { CoreTracking } from '../../../models/CoreTracking';
import { useTranslation } from 'react-i18next';
import { FlowSyncObjectType } from '../../../models/CoreModels';
import { RootState } from '../../../store/store';



const ActivityViewTrackings = () => {
    const { t } = useTranslation('schoolAdministration');

    const { activityId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.activities.activityTrackings);

    useEffect(() => {
        if (activityId !== undefined) {
            GetActivityTrackings(activityId)(dispatch);
        }
    }, [dispatch, activityId]);

    const fetchTrackings = () => {
        if (activityId !== undefined) {
            GetActivityTrackings(activityId, true)(dispatch);
        }
    }

    return (<TrackingsModule
        flowSyncObjectType={FlowSyncObjectType.Activity}
        trackings={trackings}
        noResMsg={t('trackingModule.noResMsg', { ns: 'schoolAdministration', type: t('type.activity', {ns: 'schoolAdministration'}) })}
        onDataInvalidated={fetchTrackings}
    />)
}

export default ActivityViewTrackings;
